import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"
import { contentfulLanguage, getLanguage, isSubdomain } from "../../utils"
import SingleProduct from "./single-product"

const StyledProductsList = styled.div`
  display: flex;
  flex-wrap: wrap;

  ${props =>
    props.isCenter &&
    `
    justify-content: center;
  `}

  @media (max-width: 1025px) {
    flex-direction: row;
  }

  > div {
    width: 100%;
    max-width: 33.333%;
    min-width: 22rem;
    margin-bottom: 4rem;

    @media (max-width: 1025px) {
      max-width: 50%;
      min-width: 50%;
      margin-bottom: 3rem;
    }
  }

  .gatsby-image-wrapper {
    width: 100%;
  }
`

const ProductsList = ({
  products = [],
  isSmallVersion = false,
  isCenter = false,
  showRatings = false,
}) => {
  if (!products || products.length === 0) return null
  const filteredProducts = products.filter(product => {
    const formattedLanguage = isSubdomain()
      ? isSubdomain()
      : contentfulLanguage(getLanguage().split("/")[1])

    return product.node.localeT?.indexOf(formattedLanguage) > -1
  })

  return (
    <StyledProductsList isCenter={isCenter}>
      {filteredProducts.map(item => {
        return (
          <SingleProduct
            product={item.node}
            key={item.node.contentful_id}
            isSmallVersion={isSmallVersion}
            showRatings={showRatings}
          />
        )
      })}
    </StyledProductsList>
  )
}

ProductsList.propTypes = {
  products: PropTypes.array,
  isProductsPage: PropTypes.bool,
  isCenter: PropTypes.bool,
  showRatings: PropTypes.bool,
}

export default ProductsList
